import { initializeGoogleAnalytics } from './googleAnalytics';
import { initializeHotjar } from './hotjar';

export const initializeAnalytics = () => {
  initializeGoogleAnalytics();
  initializeHotjar();
};
